import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';

import { has } from 'lodash';

import { TICKETS_PATHS } from '../../tickets/tickets';
import { AuthService } from '../../auth/auth.service';
import { TicketViewService } from '../../tickets/ticket-view/ticket-view.service';
import { Enums } from '../../../configs/Enums';
import { AuthDataInterface, AuthGroup } from '../../auth/auth';
import { BreadcrumbsService } from '../../../shared/breadcrumbs/breadcrumbs.service';

import { USERS_PATHS } from '../../users/users';
import { SECTORS_PATHS } from '../../sectors/sectors';
import { WORK_SHIFT_PATHS } from '../../work-shift/work-shift';
import { NOTIFICATIONS_PATHS } from '../../notifications/notifications';
import { WORK_SHIFTS_PATHS } from '../../work-shifts/work-shifts';
import { COMPANIES_PATHS } from '../../companies/companies';
import { NORMATIVES_PATHS } from '../../normatives/normatives';
import { NgbPopover } from '@ng-bootstrap/ng-bootstrap';
import { APP_SETTINGS_PATHS } from '../../app-settings/app-settings';
import { CHECK_LISTS_PATHS } from '../../check-lists-page/check-lists';
import { AuthGroupTypesEnum } from '../../auth/auth-group-types.enum';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'app-main',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.scss'],
  standalone: false,
})
export class MainComponent implements OnInit {
  public USERS_PATHS = USERS_PATHS;
  public SECTORS_PATHS = SECTORS_PATHS;
  public WORK_SHIFT_PATHS = WORK_SHIFT_PATHS;
  public CHECK_LISTS_PATHS = CHECK_LISTS_PATHS;
  public NOTIFICATIONS_PATHS = NOTIFICATIONS_PATHS;
  public WORK_SHIFTS_PATHS = WORK_SHIFTS_PATHS;
  public COMPANIES_PATHS = COMPANIES_PATHS;
  public APP_SETTINGS_PATHS = APP_SETTINGS_PATHS;
  public NORMATIVES_PATHS = NORMATIVES_PATHS;
  public moment = require('moment');
  public Enums = Enums;
  public currentDate: Date;
  public ticketNumber: string | null;
  public searchTicketError: string | null;
  public searchTicketErrorHighlight: string | null;
  public authData: AuthDataInterface;
  public AuthGroupTypes = AuthGroupTypesEnum;

  constructor(
    public authService: AuthService,
    private ticketViewService: TicketViewService,
    private router: Router,
    private breadcrumbsService: BreadcrumbsService
  ) {
    this.currentDate = new Date();
  }

  get showCheckLists() {
    return this.is(AuthGroupTypesEnum.Admin) || this.is(AuthGroupTypesEnum.Dispatcher) || this.is(AuthGroupTypesEnum.DispatcherGRS) || this.is(AuthGroupTypesEnum.Curator);
  }

  get showSectorCalendar() {
    return this.is(AuthGroupTypesEnum.Admin) || this.is(AuthGroupTypesEnum.Dispatcher) || this.is(AuthGroupTypesEnum.Curator) || this.is(AuthGroupTypesEnum.ServiceEngineer);
  }

  ngOnInit() {
    this.breadcrumbsService.updateBreadcrumbs([]);
    this.authService.subscribeAuthData().subscribe((authData) => {
      this.authData = authData;
    });

    this.moment.updateLocale('ru', {
      months: ['января', 'февраля', 'марта', 'апреля', 'мая', 'июня', 'июля', 'августа', 'сентября', 'октября', 'ноября', 'декабря'],
    });
  }

  public is(authGroupType: AuthGroupTypesEnum): boolean {
    return this.authService.is(authGroupType);
  }

  public onSearchTicket(): void {
    this.searchTicketError = null;
    this.searchTicketErrorHighlight = null;
    this.ticketViewService.searchTicket({ hd_ticket_number: this.ticketNumber }).subscribe(
      (response) => {
        this.router.navigate([TICKETS_PATHS.ticketLink, response['data'].id]);
      },
      (error) => {
        if (has(error, 'error.metadata.code')) {
          switch (error.error.metadata.code) {
            case 100000:
              this.searchTicketError = Enums.errorCodes[Enums.errorCodesMaps['BACKEND_ERROR']];
              this.searchTicketErrorHighlight = 'red-dark';
              break;
            case 100014:
              this.searchTicketError = 'Заявка не найдена';
              this.searchTicketErrorHighlight = 'green-dark';
              break;
            case 100040:
              this.searchTicketError = 'Нет доступа к этой заявке';
              this.searchTicketErrorHighlight = 'red-dark';
              break;
            default:
              break;
          }
        } else {
          this.searchTicketError = Enums.errorCodes[Enums.errorCodesMaps['BACKEND_ERROR']];
          this.searchTicketErrorHighlight = 'red-dark';
        }
      }
    );
  }

  public toggleWithChangeRoleContext(popover: NgbPopover): void {
    if (popover.isOpen()) {
      popover.close();
    } else {
      popover.open();
    }
  }

  public onChangeRole(group: AuthGroup) {
    this.authService.changeRole({ group_id: group.id }).subscribe(
      (response) => {
        localStorage.setItem('changeRole', Math.random() + '');
        window.location.reload();
      },
      (error) => {
        console.log(error);
      }
    );
  }
}
